import { ApiPath } from "enums";
import { Delete, Get, Post, Put } from "utils";

const getExecutiveSummaryPath = (campaignId) =>
  `${ApiPath.SurveyCampaign}/${encodeURIComponent(campaignId)}/executive-summary`;

export const getExecutiveSummary = async ({ campaignId }) => {
  const res = await Get(getExecutiveSummaryPath(campaignId));
  return res.data;
};

export const uploadExecutiveSummary = async ({
  campaignId,
  file,
  onUploadProgress,
  cancelToken,
}) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await Put(getExecutiveSummaryPath(campaignId), formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
    cancelToken,
  });
  return res.data;
};

export const deleteExecutiveSummary = async ({ campaignId }) => {
  const res = await Delete(getExecutiveSummaryPath(campaignId));
  return res.data;
};

export const createExecutiveSummaryReport = async ({ campaignCode, useLlm = true }) => {
  const res = await Post(`${ApiPath.SurveyExecutiveSummaryReport}`, {
    campaignCode,
    useLlm,
  });
  return res.data;
};

export const getExecutiveSummaryReportStatus = async ({ reportRequestId }) => {
  const res = await Get(`${ApiPath.SurveyExecutiveSummaryReport}/${reportRequestId}`);
  return res.data;
};
